import React from 'react';
import { Dropdown, DropdownProps } from '@itglue/kaseya-ui';
import { Option } from '@itglue/kaseya-ui/dist/es/components/forms/Dropdown/Dropdown';

interface PasslyDropdownProps<T extends {}> {
    id?: string;
    value?: T | T[];
    className?: string;
    options?: Option<T>[];
    optionLabel?: string;
    optionValue?: string;
    disabled?: boolean;
    placeholder?: string;
    showClear?: boolean;
    label?: string;
    appendTo?: Element;
    itemTemplate?: (option: Option<T>) => React.ReactElement;
    valueTemplate?: (option: Option<T>, props: DropdownProps<T>) => React.ReactElement;
    onChange?(e: {
        originalEvent?: React.SyntheticEvent;
        value: T | T[] | string;
        target?: {
            name: string;
            id: string;
            value: T | T[] | string;
        };
    }): void;
}

export function PasslyDropdown(props: PasslyDropdownProps<any>) {
    return (
        <>
            <Dropdown
                value={props.value}
                options={props.options}
                onChange={props.onChange}
                optionLabel={props.optionLabel}
                placeholder={props.placeholder}
                label={props.label}
                appendTo={props.appendTo}
                {...props}
            />
        </>
    );
}
